const operationalRoles = [
  {
    label: 'Administrateur',
    key: 'administrateur',
    description:
      'Als administrateur ben je een nauwkeurige en georganiseerde kracht achter de schermen. Een administrateur is goed in het verwerken van gegevens, en het analyseren en verbeteren van administratieve processen. Je zorgt voor orde, precisie en efficiëntie, en bent onmisbaar voor het soepel en betrouwbaar functioneren van elke organisatie.',
  },
  {
    label: 'Adviseur',
    key: 'adviseur',
    description:
      'Een adviseur is iemand die zijn of haar expertise en ervaring gebruikt om anderen te begeleiden en te ondersteunen. Het verzamelen en analyseren van informatie behoort tot de kern van deze rol. Als adviseur ben je bedreven in het aanpakken van complexe problemen en het aandragen van goed onderbouwde oplossingen. Bovendien ben je in staat anderen te motiveren om weloverwogen beslissingen te nemen.',
  },
  {
    label: 'Bestuurder',
    key: 'bestuurder',
    description:
      'Een bestuurder is iemand die leiderschap en besluitvaardigheid goed weet te combineren. Als bestuurder overzie je het grote geheel, ben je toekomstgericht en verantwoordelijk voor het sturen en vormgeven van de toekomst van een organisatie. Je zorgt voor de evaluatie en bijsturing van plannen, en inspireert anderen om gezamenlijk doelen te bereiken. Jij bent de sleutel tot succes en groei.',
  },
  {
    label: 'Coach',
    key: 'coach',
    description:
      'Een coach is iemand die mensen stimuleert en begeleidt in hun ontwikkeling. Als coach help je anderen bij het bereiken van hun doelen. Je bent goed in het observeren van prestaties, het geven van feedback, het stellen van doelen en het bewaken van de voortgang van deze  prestaties.',
  },
  {
    label: 'Communicator',
    key: 'communicator',
    description:
      'Een communicator is iemand die weet hoe je een boodschap tussen verschillende partijen het beste kan overbrengen. Als communicator kun jij je goed inleven in anderen en weet je informatie overtuigend, doeltreffend en impactvol over te brengen.',
  },
  {
    label: 'Controleur',
    key: 'controleur',
    description:
      'Een controleur is iemand die de kwaliteit van producten, processen en/of mensen bewaakt. Als controleur beschik je over een sterk analytisch vermogen, ben je zeer nauwkeurig en goed in het identificeren van eventuele afwijkingen.',
  },
  {
    label: 'Ordebewaarder',
    key: 'handhaver',
    description:
      'Als ordebewaarder bewaak je regels en procedures, wat essentieel is voor de orde en veiligheid binnen een organisatie. Je ziet erop toe dat normen en richtlijnen worden nageleefd en lost eventuele conflicten op. Dit vereist sterke communicatieve vaardigheden, vastberadenheid, een goed oordeelsvermogen en de capaciteit om effectief te handelen in stressvolle situaties.',
  },
  {
    label: 'Hulpverlener',
    key: 'hulpverlener',
    description:
      'Een hulpverlener is iemand die uitblinkt in het helpen van anderen. Je bent behulpzaam, zorgzaam en empathisch. Als hulpverlener bied je niet alleen hulp, begeleiding en ondersteuning, maar ben je ook essentieel voor het welzijn en de verbetering van anderen.',
  },
  {
    label: 'Digitaliseringsexpert',
    key: 'icter',
    description:
      'Als digitaliseringsexpert ben je een specialist op het gebied van technologie en digitale processen. Je optimaliseert systemen en processen en draagt bij aan de efficiëntie en groei van organisaties door slim gebruik te maken van technologie. Je bent creatief, analytisch en oplossingsgericht, en kunt complexe technische concepten begrijpelijk maken voor anderen.',
  },
  {
    label: 'Creatieveling',
    key: 'kunstenaar',
    description:
      'Een creatieveling is iemand die met originele, innovatieve en creatieve ideeën komt. Als creatieveling zoek je altijd naar nieuwe manieren om problemen op te lossen en kansen te benutten. Je denkt buiten de gebaande paden en staat open voor nieuwe ideeën. Jouw rol stimuleert creativiteit en innovatie binnen een organisatie door een frisse en originele aanpak van projecten en taken.',
  },
  {
    label: 'Leider',
    key: 'leider',
    description:
      'Een leider is iemand die uitblinkt in het sturen, motiveren en inspireren van anderen. Je bent goed in het maken van beslissingen, biedt richting en leidt teams naar gemeenschappelijke doelen. Je hebt sterke leiderschapsvaardigheden om de organisatie te begeleiden en te laten groeien.',
  },
  {
    label: 'Kennisoverdrager',
    key: 'leraar',
    description:
      'Een kennisoverdrager is iemand die goed is in het overdragen van kennis en vaardigheden. Als kennisoverdrager inspireer, onderwijs en begeleid je mensen, en speel je een cruciale rol in de groei van anderen. Je bent behulpzaam, empathisch en geduldig. Daarnaast ben je goed in het observeren van prestaties en het geven van feedback.',
  },
  {
    label: 'Duurzaamheidspionier',
    key: 'natuurmens',
    description:
      'Een duurzaamheidspionier is iemand die zich inzet voor het bevorderen van duurzaamheid en milieubewustzijn. Je bent gedreven, creatief en vastberaden in het vinden van groene oplossingen. Met jouw positieve houding en inspirerende aanpak motiveer je anderen om milieubewust te leven en bij te dragen aan een groenere toekomst.',
  },
  {
    label: 'Ondernemer',
    key: 'ondernemer',
    description: `Een ondernemer is iemand die initiatief neemt, kansen ziet en benut, en nieuwe ideeën of ondernemingen ontwikkelt. Deze rol omvat het vinden van nieuwe manieren om te groeien en succes te behalen door innovatie, het durven nemen van risico's en leiderschap te tonen. Ondernemers nemen beslissingen, sturen teams aan en passen zich flexibel aan terwijl ze vooruitkijken. Als ondernemer kun je verschillende aspecten van de bedrijfsvoering managen.`,
  },
  {
    label: 'Ondersteuner',
    key: 'ondersteuner',
    description:
      'Een ondersteuner is iemand die anderen helpt in hun werk. Als ondersteuner zorg je ervoor dat processen soepel verlopen en dat de werkomgeving productief is. Je pakt taken op, bent communicatief sterk, goed in het oplossen van problemen en het bedenken van nieuwe ideeën.',
  },
  {
    label: 'Onderzoeker',
    key: 'onderzoeker',
    description:
      'Een onderzoeker is iemand die informatie verzamelt en analyseert, verbanden weet te ontdekken en te verklaren, en conclusies kan trekken. Je bent nieuwsgierig en altijd op zoek naar nieuwe kennis. Jouw rol is cruciaal bij het oplossen van ingewikkelde vraagstukken en het bedenken van nieuwe ideeën en oplossingen, en je kunt helder communiceren.',
  },
  {
    label: 'Projectleider',
    key: 'projectleider',
    description:
      'Een projectleider is iemand die leiderschap met organisatietalent weet te combineren. Jij bent de drijvende kracht achter het leiden van projecten. Jouw kracht ligt in het maken en volgen van een planning, het coördineren van teams, en het zorgen dat doelen binnen de beoogde tijd worden bereikt.',
  },
  {
    label: 'Technicus',
    key: 'technicus',
    description:
      'Als technicus ben je cruciaal bij het oplossen van technische vraagstukken en het ondersteunen van de technologische infrastructuur van de organisatie. Je beschikt over probleemoplossend vermogen en technisch inzicht, wat je combineert met praktische vaardigheden om systemen en processen te repareren, verbeteren of onderhouden.',
  },
  {
    label: 'Verkoper',
    key: 'verkoper',
    description:
      'Een verkoper is iemand die overtuigend en klantgericht is. Door sterke relaties op te bouwen en goed te luisteren naar anderen, ben je in staat om hen te begrijpen en te overtuigen. Als verkoper ben je cruciaal in het behalen van doelen en het opbouwen van duurzame relaties.',
  },
  {
    label: 'Vernieuwer',
    key: 'vernieuwer',
    description:
      'Als vernieuwer ben je de drijvende kracht achter verandering en innovatie. Je denkt buiten de gebaande paden, komt met creatieve oplossingen en stimuleert vernieuwing. Daarnaast ben je in staat anderen te overtuigen van jouw ideeën en weet je effectief samen te werken om deze te realiseren.',
  },
  {
    label: 'Verzorger',
    key: 'verzorger',
    description:
      'Een verzorger is iemand die zich inzet om anderen te helpen en te ondersteunen. Je bent zorgzaam, empathisch, attent en toegewijd aan het helpen en verzorgen van mensen. Jouw bijdrage draagt bij aan een positieve en zorgzame omgeving. Als verzorger ben je cruciaal in het bevorderen van gezondheid en geluk.',
  },
]

export default operationalRoles
